import request from "@/yintai/utils/request";

export function fetchStore(data) {
  return request({
    url: "/store/out/list",
    method: "post",
    data,
  });
}
